export default __webpack_public_path__ + "static/media/about.89d7aa41.mp4";